// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1S2Tl","productName":"Table_productName__PmptP"};